import { Box } from '@mui/material';
import { isValid } from 'date-fns';
import parseDate from 'date-fns/parse';

import { Text } from '../layout';

import { Project } from '@arra/core';
import { User } from '../../../authentication/context/useUser';
import { getProjectTitleWOYear } from '../../context/useProject';

const allowedDateFormats = ['yyyy-MM-dd', 'dd/MM/yyyy'];

const excelDateToJSDate = (excelDate: number) => {
  // Excel epoch starts on January 1, 1900
  const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // Adjusted for Excel bug
  // Convert Excel serial date to milliseconds and add to the epoch
  const jsDate = new Date(
    excelEpoch.getTime() + excelDate * 24 * 60 * 60 * 1000,
  );
  return jsDate;
};

const checkDate = (value: any) => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'string') {
    for (const format of allowedDateFormats) {
      const date = parseDate(
        value.substring(0, Math.min(value.length, format.length)),
        format,
        new Date(),
      );
      if (isValid(date)) {
        return date;
      }
    }
  }
  if (typeof value === 'number') {
    return excelDateToJSDate(value);
  }
  return null;
};

export const Footer = ({
  project,
  user,
  withBorder = true,
}: {
  project: Project;
  user: User;
  withBorder?: boolean;
}) => {
  const projectName = getProjectTitleWOYear(project);
  const structureName = user?.company;
  return (
    <Box
      marginTop="auto"
      display="flex"
      marginBottom="40px"
      justifyContent="space-evenly"
      columnGap={2}
      paddingX={2}
      height="1.5cm"
      sx={
        withBorder
          ? {
              boxSizing: 'border-box',
              borderRight: '1cm solid var(--PURPLE)',
            }
          : {}
      }
    >
      <Box display="flex" flexDirection="column" rowGap={2}>
        <Text fontSize="12px" fontWeight="bold">
          Nom
          <br /> de la radio
        </Text>
        <Text fontSize="10px">{structureName}</Text>
      </Box>
      <Box borderLeft={1} borderColor="var(--PURPLE)" />
      <Box display="flex" flexDirection="column" rowGap={2}>
        <Text fontSize="12px" fontWeight="bold">
          Service <br />
          (nom du projet)
        </Text>
        <Text fontSize="10px">{projectName}</Text>
      </Box>
      <Box borderLeft={1} borderColor="var(--PURPLE)" />
      <Box display="flex" flexDirection="column" rowGap={2}>
        <Text fontSize="12px" fontWeight="bold">
          Année <br />
          étudié
        </Text>
        <Text fontSize="10px">{project.year}</Text>
      </Box>
    </Box>
  );
};
